import { render, staticRenderFns } from "./AdminNotices.vue?vue&type=template&id=60b89682&scoped=true"
import script from "./AdminNotices.vue?vue&type=script&lang=js"
export * from "./AdminNotices.vue?vue&type=script&lang=js"
import style0 from "./AdminNotices.vue?vue&type=style&index=0&id=60b89682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b89682",
  null
  
)

export default component.exports